/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Level2OuterPageLayout } from "@octopusdeploy/design-system-components";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { compact } from "lodash";
import * as React from "react";
import { useCreatePageSideNavLink } from "~/hooks/useCreatePageSideNavLink";
interface MyProfileLayoutProps {
    children: React.ReactNode;
}
export function MyProfileLayout({ children }: MyProfileLayoutProps) {
    const createPageSideNavLink = useCreatePageSideNavLink();
    const navLinks = compact([
        createPageSideNavLink("My Profile", links.myProfilePage.generateUrl()),
        createPageSideNavLink("My Logins", links.myLoginsPage.generateUrl()),
        createPageSideNavLink("My API Keys", links.myApiKeysPage.generateUrl()),
        createPageSideNavLink("My Recent Activity", links.myRecentActivityPage.generateUrl(), null!, { permission: Permission.EventView, wildcard: true }),
    ]);
    return (<main>
            <Level2OuterPageLayout navItems={navLinks} header={{ title: "My Profile" }}>
                {children}
            </Level2OuterPageLayout>
        </main>);
}
